import { format } from 'date-fns';
export const AppConfig = {API_BASE_URL: 'https://localhost:8081/api/v1/sub/'};

export const convertDate = (inputDate) => {
    const dateObj = new Date(inputDate);
    return format(dateObj, 'dd-MM-yyyy HH:mm:ss');
};

export function formatNumber(num) {
    const suffixes = ['', 'K', 'M', 'B', 'T'];
    let suffixIndex = 0;

    while (num >= 1000 && suffixIndex < suffixes.length - 1) {
        num /= 1000;
        suffixIndex++;
    }

    let formattedNum = num.toFixed(2);

    // Supprimer les .00 inutiles
    if (formattedNum.endsWith('.00')) {
        formattedNum = parseInt(formattedNum).toString();
    }

    return formattedNum + suffixes[suffixIndex];
}

export function shareOnFacebook() {
    const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href);
    window.open(url, '_blank');
}

export default {AppConfig, convertDate, formatNumber, shareOnFacebook};
